import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

const BREAKPOINT_MOBILE = 768;

function setDataWidth($list : JQuery) {
	// Store each items outer-with inclusive margin
	$list.each((_idx, element) => {
		const $li = $(element);
		$li.data('width', $(element).outerWidth(true) || 0);
	});
}

/**
 * Level 2 of header support
 *
 * @author Nikola Tica
 * @class HeaderLvl2
 * @extends Tc.Module
 */
export default class HeaderLvl2 extends Module {
	private mediaQueryList! : MediaQueryList;

	public on(callback : Hook) {
		this.mediaQueryList = window.matchMedia(`(max-width: ${BREAKPOINT_MOBILE}px)`);

		if (this.$ctx.find('.scsh-lvl2-navi > li').length) {
			this.initBreakDown();

			this.$ctx.find('.scsh-lvl2-container.scsh-has-child-pages h1').on('click', (evt : JQuery.ClickEvent) => {
				if (this.mediaQueryList.matches) {
					$(evt.target).toggleClass('active').closest('.scsh-lvl2-container').find('.scsh-lvl2-navi').toggleClass('active');
				}
			});

			// Listener for click on overflow-nav dropdown
			this.$ctx.find('.scsh-lvl2-overflow-container > a').on('click', () => {
				const overflowContainer = this.$ctx.find('.scsh-lvl2-overflow-container');

				overflowContainer.trigger('scsh-flyout-open', [() => overflowContainer.removeClass('scsh-active')]);
				overflowContainer.addClass('scsh-active');
			});

		}
		this.initiTracking();
		callback();
	}

	/**
	 * Setup functionality for putting level 2 navigations links on dropdown in
	 * `more` button depending on screen size
	 */
	private initBreakDown() {
		const $nav = this.$ctx.find('.scsh-lvl2-navi');
		const $overflowNav = this.$ctx.find('.scsh-lvl2-overflow-navi');
		const $overflowContainer = this.$ctx.find('.scsh-lvl2-overflow-container');
		const $maxXPosElement = $nav.closest('.scsh-lvl2-container');
		const $firstNavItem = $nav.children().first();
		const firstNavItemSpacingToTitle = ($firstNavItem.css('margin-left') || '0').replace('px', '');
		let lastHeaderWidth = 0;
		let overflowNavVisible = false;
		let $mobilizedItems = $();
		let widthCalculated = false;

		if(!this.mediaQueryList.matches) {
			setDataWidth($nav.children());
			widthCalculated = true;
		}

		let resizeTimeout : number | undefined;

		$(window).on('resize', () => {
			// Use timeout to throttle
			window.clearTimeout(resizeTimeout);
			resizeTimeout = window.setTimeout(() => {
				const headerWidth = this.$ctx.width() || 0;
				let $navItems = $nav.children();

				// Do not do anything if (complete) mobile view is active
				if (this.mediaQueryList.matches) {
					if (!$mobilizedItems.length) {
						$mobilizedItems = $overflowNav.children().appendTo($nav);
					}

					return;
				}

				if ($mobilizedItems.length) {
					if(!widthCalculated) {
						widthCalculated = true;
						setDataWidth($nav.children());
					}

					$mobilizedItems.appendTo($overflowNav);
					$mobilizedItems = $();
				}

				if ((headerWidth < lastHeaderWidth || !lastHeaderWidth) && $navItems.length > 1) {
					// Screen got smaller -> check for moving items to overflow nav
					const maxXPos = Math.round($maxXPosElement.offset()!.left + $maxXPosElement.width()!);
					let $lastElement = (overflowNavVisible ? $overflowContainer : $navItems.last());

					// Move all but the first item into overflow navi (ignore frst one to prevent just having the overflow navi there)
					while ($navItems.length > 1 && Math.floor($lastElement.offset()!.left + $lastElement.outerWidth()!) > maxXPos) {
						const $lastNavItem = $navItems.last();

						// Move to overflow-list
						$lastNavItem.prependTo($overflowNav);

						// Remove the last item from the set
						$navItems = $navItems.not($lastNavItem);

						if (!overflowNavVisible) {
							$overflowContainer.addClass('is-visible');
							overflowNavVisible = true;
							$lastElement = $overflowContainer;
						}
					}
				} else if (headerWidth > lastHeaderWidth && overflowNavVisible) {
					// Screen got bigger -> check for moving items back to normal nav
					let availableSpace = Math.floor($firstNavItem.offset()!.left -
					parseInt(firstNavItemSpacingToTitle, 10) - $nav.offset()!.left);
					let $overflowItems = $overflowNav.children();
					let $firstOverflowElement = $overflowItems.first();

					while ($overflowItems.length && availableSpace >= $firstOverflowElement.data('width')) {
						// Move back to normal-list
						$firstOverflowElement.appendTo($nav);

						// Reduce available space by the moved elements width
						availableSpace -= $firstOverflowElement.data('width');

						// Get new first item in overflow-nav
						$overflowItems = $overflowItems.not($firstOverflowElement); // Remove the first item from the set
						$firstOverflowElement = $overflowItems.first(); // Get the new first item

						if (!$overflowItems.length) {
							$overflowContainer.removeClass('is-visible');
							overflowNavVisible = false;
						}
					}
				}

				lastHeaderWidth = headerWidth;
			}, 10);
		});

		$(window).trigger('resize');
	}

	private initiTracking() {
		// Back button
		this.$ctx.find('.scsh-dynamic scsh-lvl2-area .scsh-back').on('click', e => {
			scsHeader.siteCatalyst.trackClick(e.currentTarget, e, 'back', 'l2-navigation');
		});
		// Level 2 links
		this.$ctx.find('.scsh-dynamic .scsh-lvl2-area .scsh-lvl2-navi li a').on('click', e => {
			scsHeader.siteCatalyst.trackClick(
				e.currentTarget,
				e,
				$(e.currentTarget).data('tracking-link-name') || $(e.currentTarget).find('h3').text(),
				'l2-navigation',
			);
		});
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/header/Tc.Module.HeaderLvl2.ts